const translations = {
    copyrightLeft: 'COPYRIGHT',
    copyrightRight: '{{currentYear}} AcreConnect'
};

export default translations;
